import { useSelector } from "react-redux";
import { sumOfRecordCountsWithoutDecimal } from "../../../helper/utility";
import { Constants } from "../../Common/Constants";
import AreaGraphMonthly from "../../Common/Graphs/AreaGraphMonthyl";


const Quarterly = () => {
  // const { workoutanalytics } = useSelector((store) => store.Reports);
  const userStrengthAssessment = useSelector((store) => store.WorkOutAnalyticsReportReducer.exerciseWiseStrengthAssessmentReport);
  const sumOfUserStrengthAssessment = sumOfRecordCountsWithoutDecimal(userStrengthAssessment);


  return (
    <div className="row mt-4">
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.userStrengthAssessment}
          data={userStrengthAssessment}
          title={`${Constants.strengthAssessment} ${sumOfUserStrengthAssessment}`}
          format=""
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Quarterly;
